import React from 'react';

export default function Table({ headers, children, empty = 'Məlumat yoxdur' }) {
  return (
    <div className="admin-table-shell" role="region" aria-label="Data table" tabIndex="0">
      <p className="table-scroll-hint">Scroll horizontally to see every column and action.</p>
      <table className="admin-table">
        <thead>
          <tr>
            {headers.map(h => (
              <th key={h} scope="col">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {React.Children.count(children) === 0
            ? <tr><td colSpan={headers.length} className="text-center py-10 text-gray-400">{empty}</td></tr>
            : children}
        </tbody>
      </table>
    </div>
  );
}
